export default __webpack_public_path__ + "static/media/minio1.4ab8b863.jpg";